import React from "react";
import styles from "./style.scss";
import cn from "classnames";
import { SkeletonArticle } from "../Article";
import { SkeletonTab } from "../Tab";
import { BinderType } from "models/BinderItem";
import Pin from "images/icon/icn_pin_fill_16_unactive.svg";
import Mail from "images/icon/mail_inspector_unset.svg";
import Share from "images/icon/share_unactive_16.svg";
import More from "images/icon/action_menu.svg";

interface Props {
  type: BinderType;
}
export const SkeletonLoading: React.FunctionComponent<Props> = ({ type }) => {
  const binderNum = 6;
  return (
    <div className={styles.skeletonWrapper}>
      {Array.from({ length: binderNum }).map((_, index) => (
        <div
          key={`skeleton-binder-${index}`}
          className={cn(styles.binder, { [styles.nikkei]: type === "nikkei" })}
        >
          <div className={styles.header}>
            <div className={styles.metaWrapper}>
              {type === "personal" && <img className={styles.pin} src={Pin} />}
              <div className={cn(styles.skeletonText, styles.meta)} />
              <div className={styles.icons}>
                {type === "personal" && (
                  <img className={styles.operator} src={Mail} />
                )}
                {type === "personal" && (
                  <img className={styles.operator} src={Share} />
                )}
                {type === "personal" && (
                  <img
                    className={cn(styles.operator, styles.more)}
                    src={More}
                  />
                )}
              </div>
            </div>
          </div>
          <div className={styles.descriptionWrapper}>
            <div className={cn(styles.skeletonText, styles.descriptionTop)} />
            <div
              className={cn(styles.skeletonText, styles.descriptionBottom)}
            />
          </div>
          <SkeletonArticle />
          <SkeletonTab />
          {type === "nikkei" && (
            <div className={styles.collectWrapper}>
              <div className={cn(styles.skeletonText, styles.collect)} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
